var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 14.9231C12.2712 14.9231 14.9231 12.2712 14.9231 9C14.9231 5.72878 12.2712 3.07692 9 3.07692C5.72878 3.07692 3.07692 5.72878 3.07692 9C3.07692 12.2712 5.72878 14.9231 9 14.9231ZM9 16C12.866 16 16 12.866 16 9C16 5.13401 12.866 2 9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16ZM4.69234 8.99994C4.69234 8.70256 4.93341 8.46148 5.2308 8.46148H8.46154V5.23077C8.46154 4.93338 8.70262 4.69231 9 4.69231C9.29739 4.69231 9.53846 4.93338 9.53846 5.23077V8.46148H12.7693C13.0666 8.46148 13.3077 8.70256 13.3077 8.99994C13.3077 9.29732 13.0666 9.5384 12.7693 9.5384H9.53846V12.7692C9.53846 13.0666 9.29738 13.3077 9 13.3077C8.70262 13.3077 8.46154 13.0666 8.46154 12.7692V9.5384H5.2308C4.93341 9.5384 4.69234 9.29732 4.69234 8.99994Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBlack);
export default __webpack_public_path__ + "static/media/add-black.bf47446ae175b3783575a9f2322e50b2.svg";
export { ForwardRef as ReactComponent };